<template>
  <pt-counselor-manage class="pt-counselor-manage__page"></pt-counselor-manage>
</template>

<script>
import PtCounselorManage from 'cps//pt-counselor-manage/withData'
export default {
  name: 'pt-counselor-manage__view',
  components: {
    'pt-counselor-manage': PtCounselorManage
  }
}
</script>
